<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold ">{{mode}} Loan Payments</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">
                <v-layout v-if="mode=='Add'" row wrap>
                    <v-flex v-if="isRequestForOtherUser&&mode=='Add'"  xs12 sm12 class="form-row">
                        <v-autocomplete
                            v-model="requestForUserId"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Request for Employee"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-avatar>
                                        <img :src="data.item.avatar">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 class="form-row">
                        <v-select
                            label="Loan Payment Type"
                            :items="loan_types"
                            :rules="[rules.required]"
                            item-text="loanType"
                            item-value="loanTypeId"
                            :disabled="disabled"
                            :loading="loading_types"
                            v-model="loanTypeId"
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm4 class="form-row">
                        <v-menu v-model="menuLoanDate" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="loanDate" label="Loan Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                            </template>
                            <v-date-picker no-title v-model="loanDate" @input="menuLoanDate=false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm4 class="form-row">
                        <v-text-field label="Principal Amount"
                            v-model="principalAmount"
                            :disabled="disabled"
                            :rules="[rules.required_numeric,rules.max_amount]"
                            type="number" min="1" step="1" value="0.00"
                            hint="Loan amount as of Loan Date"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 class="form-row">
                        <v-text-field label="Total Amount to Pay"
                            v-model="totalDue"
                            :disabled="disabled"
                            :rules="[rules.required_numeric,rules.max_amount]"
                            type="number" min="1" step="1" value="0.00"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 class="form-row">
                        <v-text-field label="Monthly Amount to Pay"
                            v-model="monthlyDue"
                            :disabled="disabled"
                            :rules="[rules.required_numeric]"
                            type="number" min="1" step="1" value="0.00">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 class="form-row">
                        <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="startDate" label="Payment Start Month" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                            </template>
                            <v-date-picker no-title type="month" v-model="startDate" :allowed-dates="allowedDates" @input="menuStartDate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex v-if="isBiMonthlyCutoff" xs12 sm4 class="form-row">
                        <v-select
                            label="Payment Start CutOff"
                            :items="payment_start_cutoff"
                            :rules="[rules.required]"
                            item-text="description"
                            item-value="cutOff"
                            :disabled="disabled"
                            v-model="paymentCutOffStart"
                        ></v-select>
                    </v-flex>
                    <v-flex v-if="isBiMonthlyCutoff" xs12 sm6 class="form-row">
                        <v-select
                            label="Deduction Mode"
                            :items="getPayoutTypes"
                            :rules="[rules.required]"
                            item-text="description"
                            item-value="payoutMode"
                            :disabled="disabled"
                            v-model="deductionMode"
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 v-if="showComment" style="padding:10px 10px 0px 15px; ">
                        <v-textarea v-model="remarks" outline label="Comments" rows="1" color="primary"></v-textarea>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="showComment=!showComment" title="Add Comment">
                    <v-icon>comment</v-icon>
                </v-btn>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading" style="color:white">{{mode}}</v-btn>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled" >Clear</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import loansApi from '@/api/loans'
import cutoffApi from '@/api/cutoff'
import employeeApi from '@/api/employees'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'
import { getPayoutTypes } from '@/constants/payout-types'

export default {
    data () {
        return {
            common_data: null,
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            loading_employees: false,
            loading_types: false,
            rules: {
                required: value => !!value || 'Required field.',
                required_numeric: value => !!value || 'Required field. Numeric Only',
                max_amount: value => value<=10000000 || 'Invalid Amount. Maximum of 10,000,000.00' 
            },
            mode: '',
            isRequestForOtherUser: null,
            menuStartDate: false,
            menuLoanDate: false,
            menuMaturityDate: false,
            requestForUserId: null,
            userId: null,
            loanTypeId: null,
            totalDue: null,
            loanDate: null,
            principalAmount: null,
            monthlyDue: null,
            startDate: null,
            deductionMode: null,
            remarks: "",
            showComment: false,
            paymentCutOffStart: null,
            payment_start_cutoff: [
                { cutOff: 1, description: '1st CutOff' },   
                { cutOff: 2, description: '2nd CutOff' }
            ],
            employees: [],
            loan_types: [],
            months: [],
            years: [],
            cutoff_setting: null,
            pageKey: null
        }
    },
    methods: {
        allowedDates(val) {
            const oneMonthEarlier = this.$moment().subtract(1, 'month').startOf('month');
            const selectedMonth = this.$moment(val).startOf('month');
            return selectedMonth.isSameOrAfter(oneMonthEarlier);
        },
        async addUpdate() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    var data = {
                        loanId: this.loanId,
                        isRequestForOtherUser: this.isRequestForOtherUser,
                        requestForUserId: this.requestForUserId,
                        userId: this.userId,
                        loanTypeId: this.loanTypeId,
                        loanDate: this.loanDate,
                        principalAmount: this.principalAmount,
                        totalDue: this.totalDue,
                        monthlyDue: this.monthlyDue,
                        startDate: this.startDate,
                        deductionMode: this.deductionMode,
                        paymentCutOffStart: this.paymentCutOffStart,
                        remarks: this.remarks
                    }
                    var response = null
                    if (this.mode == 'Add')
                        response = await loansApi.add(data, this.pageKey)
                    else
                        response = await loansApi.update(data, this.pageKey)

                    if (response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setAdd(data) {
            this.mode = 'Add'
            this.isRequestForOtherUser = data.isRequestForOtherUser
            this.pageKey = data.pageKey

            if (this.isRequestForOtherUser && this.employees.length==0) await this.getEmployees()
            if (this.loan_types.length==0) await this.getTypes()
            if (this.cutoff_setting == null) await this.getCuttoffSettings()
        },
        async setUpdate(data, pageKey) {
            this.mode = 'Update'
            this.pageKey = pageKey
            this.isRequestForOtherUser = data.isRequestForOtherUser
            
            if (this.loan_types.length==0) await this.getTypes()
            if (this.cutoff_setting == null) await this.getCuttoffSettings()
            
            this.loanId = data.loanId
            this.userId = data.userId
            this.loanTypeId = data.loanTypeId
            this.loanDate = data.loanDate ? this.$moment(data.loanDate).format('YYYY-MM-DD') : data.loanDate
            this.principalAmount = data.principalAmount
            this.totalDue = data.totalDue
            this.monthlyDue = data.monthlyDue
            this.startDate = this.$moment(data.startDate).format('YYYY-MM')
            this.deductionMode = data.deductionMode
            this.paymentCutOffStart = data.paymentCutOffStart
            this.remarks = data.remarks
        },
        async getCuttoffSettings() {
            try {
                this.disabled = true
                this.loading = true
                const response = await cutoffApi.getSettings()
                if (response && response.status == 200) {
                    this.cutoff_setting = response.data.item
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getTypes() {
            try {
                this.disabled = true
                this.loading_types = true
                const response = await loansApi.getTypes(this.pageKey)
                if (response && response.status == 200) {
                    this.loan_types = response.data.items
                }
                this.loading_types = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAllByPageKey(pageKeys.loans)
                if (response && response.status == 200) {
                    const members = response.data.employees
                    members.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            group: item.team
                        })
                    })    
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        closeDialog() {
            this.$emit('update:dialogLoans', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.remarks = ''
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
    computed: {
        isBiMonthlyCutoff() {
            if (this.cutoff_setting) {
                return this.cutoff_setting.type === "2"
            }
        },
        getPayoutTypes() {
            return getPayoutTypes(this.isBiMonthlyCutoff)
        },
    }
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 0px 15px 0px 15px;
}
</style>